import { useInvitationsQuery } from '@platform/state/api';

/**
 * Кількість запрошень простору, що очікують відповіді (прототип v4: плитка «Запрошення · очікує», лічильники меню Головної й
 * «Адміністрування», підзаголовок учасників): перелік GET /workspaces/{id}/invitations (кеш RTK Query спільний зі сторінкою
 * «Запрошення»). До відповіді — undefined; сервер без цього API — 0.
 */
export function usePendingInvitations(ws: string): number | undefined {
  const { data } = useInvitationsQuery(ws, { skip: !ws });
  return data ? data.items.filter((i) => i.status === 'pending').length : undefined;
}
